import { z } from 'zod';

/**
 * Маппинг slug категории события → slug сферы жизни (колесо баланса). Категории
 * вне карты (`other` и любые неизвестные) в колесо не вносят вклада. Хардкод —
 * категорий из сида немного и они стабильны (см. profile-port план, пункт 5).
 */
export const CATEGORY_TO_SPHERE: Record<string, string> = {
  creativity: 'creativity',
  fun: 'social',
  activity: 'health',
  growth: 'mental',
  social: 'social',
};

/** Вклад одного посещённого события в сферу, % (легаси: 10 событий = 100%). */
export const SPHERE_PERCENT_PER_EVENT = 10;

export function spherePercentFromCount(count: number): number {
  return Math.min(100, count * SPHERE_PERCENT_PER_EVENT);
}

export const BalanceSphereDto = z.object({
  slug: z.string(),
  name: z.string(),
  emoji: z.string(),
  color: z.string(),
  percent: z.number().int().min(0).max(100),
});
export type BalanceSphereDto = z.infer<typeof BalanceSphereDto>;

export const BalanceWheelDto = z.object({
  spheres: z.array(BalanceSphereDto),
  // Средний процент по всем сферам — «осознанность» (как в игре «Выход из Матрицы»).
  awarenessPercent: z.number().int().min(0).max(100),
});
export type BalanceWheelDto = z.infer<typeof BalanceWheelDto>;
